module.exports = __webpack_public_path__ + "static/media/whatsapp-solid.b54dec9c.svg";